export const translation = {
  welcome: "welcome",
  limit: "limit",
  exclusive: "exclusive",
};
